// This icon file is generated automatically.
var PCaretUpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.42 8.77L6.29 2.82a.4.4 0 00-.58 0L.58 8.77c-.2.22-.02.54.29.54h10.26c.3 0 .48-.32.29-.54z", "fill-rule": "nonzero" } }] }, "name": "p-caret-up", "theme": "outlined" };
export default PCaretUpOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCaretUpOutlined.js
// module id = 3270
// module chunks = 0